import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const import_c = (folder, component) => {
    return import(`./${folder}/${component}`)
}

export default new Router({
    mode: 'history',
    scrollBehavior() {
        return { x: 0, y: 0 }
    },

    routes: [
        {
            path: '',
            name: 'viewer',
            beforeEnter: (to, from, next) => {
                window.Intercom('update', {
                    project_id: -1,
                })
                next()
            },
            component: () => import_c('views', 'Project/360Viewer'),
        },
        {
            path: '*',
            name: 'page-not-found',

            component: () => import_c('views', 'Special/PageNotFound'),
        },
    ],
})
